function hasValidSubscription(subscription) {
	if (!subscription) return false;

	const { validFrom, validTo, recurring } = subscription;

	if (!recurring) return false;

	const now = Date.now();

	return now >= Number(validFrom) && now < Number(validTo);
}

export const getUserSubscriptionData = (data) => {
	const { packages, packagesCombination, user } = data;

	let allPackages = [...(packages?.packages ?? []), ...(packagesCombination?.packages ?? [])];
	allPackages = Array.from(new Map(allPackages.map((pkg) => [pkg.id, pkg])).values());

	const allSubscriptionPackages = allPackages?.filter((el) => el?.recurring);
	const allRecurringActiveProducts = user?.buyerProducts?.filter(hasValidSubscription) ?? [];

	const isUserSubscribed = allRecurringActiveProducts.some((userProduct) =>
		allSubscriptionPackages.some((pkg) => pkg.sku === userProduct.sku)
	);

	return { isUserSubscribed };
};
